import { FC } from 'react'
import { BuyerContextRegionsQuery } from 'graphql/types'
import PreFooter from 'components/PreFooter'
import PreFooterSearchLinks from 'components/PreFooter/components/PreFooterSearchLinks'
import styles from './PreFooter.module.scss'

type TProps = {
  regions?: BuyerContextRegionsQuery | undefined
}

const PreFooterSection: FC<TProps> = ({ regions }) => {
  return (
    <div className={styles.ecRegionsServedPreFooterWrapper}>
      <PreFooter hideBorder>
        <PreFooterSearchLinks
          title="Veja o que as pessoas estão buscando"
          hideAnotherSection
          itemsPerColumn={10}
          totalColumns={3}
          regions={regions}
        />
      </PreFooter>
    </div>
  )
}

export default PreFooterSection
